import cx from 'classnames'

const badgeToneClasses = {
  amber: 'tw:border-status-warning-border tw:bg-status-warning-surface tw:text-status-warning-foreground',
  blue: 'tw:border-status-info-border tw:bg-status-info-surface tw:text-status-info-foreground',
  gray: 'tw:border-status-neutral-border tw:bg-status-neutral-surface tw:text-status-neutral-foreground',
  green: 'tw:border-status-success-border tw:bg-status-success-surface tw:text-status-success-foreground',
  ink: 'tw:border-action tw:bg-action tw:text-action-foreground',
  red: 'tw:border-status-danger-border tw:bg-status-danger-surface tw:text-status-danger-foreground',
}

export const Badge = ({ children, className, dot = false, tone = 'gray', ...props }) => (
  <span className={cx('tw:inline-flex tw:items-center tw:gap-1 tw:rounded-pill tw:border tw:px-2 tw:py-1 tw:text-sm', badgeToneClasses[tone], className)} {...props}>
    {dot && <span className="tw:h-1.5 tw:w-1.5 tw:rounded-full tw:bg-current" />}
    {children}
  </span>
)
